import { TDtoPaginationEntry } from "./__types__/TDtoPaginationEntry";
import { TParseDto } from "../__types__/dto";
import { isArray, isNumber } from "lodash";

export const DtoPaginationParser = <
  P extends (...args: any) => any = TParseDto
>(
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  data: any,
  itemParser: P
): TDtoPaginationEntry<ReturnType<P>> => ({
  data:
    (isArray(data.data) && data.data.map(itemParser)) ||
    (isArray(data.list) && data.list.map(itemParser)) ||
    [],
  meta: {
    current_page: isNumber(data.meta?.current_page)
      ? data.meta.current_page
      : 0,
    last_page: isNumber(data.meta?.last_page) ? data.meta.last_page : 1,
    per_page: isNumber(data.meta?.per_page) ? data.meta.per_page : 10,
    total: isNumber(data.meta?.total) ? data.meta.total : 0,
  },
});
